// 現在開いているページのURLを取得
function getCurrentPageUrl(){
    // urlを取得
    var locationUrl = location.href;

    // check current Lang
    var langList = {
        'ko':'https://shop.xgalx.com/ko',
        'zh':'https://shop.xgalx.com/zh',
        'tw':'https://zh.shop.xgalx.com',
        'ja':'https://shop.xgalx.com/ja',
        'en':'https://shop.xgalx.com'
    };

    // page URL
    var locationPageUrl = '';

    if( locationUrl.indexOf( langList['ko'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['ko'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['zh'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['zh'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['tw'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['tw'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['ja'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['ja'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['en'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['en'] )[1].split("?")[0];

    }

    // page URL綺麗にするために配列化
    var locationPageUrlList = locationPageUrl.split('/');

    // 頭の/を除いたパスを格納する配列
    var pageUrlList = [];
  
    for(var i = 0; i < locationPageUrlList.length; i++){
      // 値が空でなければ、パスを追加
      if( locationPageUrlList[i] !== '') {
        pageUrlList.push(locationPageUrlList[i] );
      }
    }

    // 商品説明を取得
    var pageUrl = pageUrlList.join('/');

    return pageUrl;
}

// 指定された言語にリダイレクト
function redirectLangPage( setLang ) {
    // sサイト URL
    var siteUrl = '';

    // パラメータ
    var queryParam = '?currency=jpy';

    // リダイレクトするURLとクエリパラメータを取得
    if(setLang == "usd") {
        siteUrl = 'https://shop.xgalx.com';
        //queryParam = '?currency=usd';

    } else if(setLang == "krw") {
        siteUrl = 'https://shop.xgalx.com/ko';
        //queryParam = '?currency=krw';

    } else if(setLang == "cny") {
        siteUrl = 'https://shop.xgalx.com/zh';
        //queryParam = '?currency=cny';

    } else if(setLang == "twd") {
        siteUrl = 'https://zh.shop.xgalx.com';
        queryParam = '?currency=twd';

    } else if(setLang == "jpy") {
        siteUrl = 'https://shop.xgalx.com/ja';
        queryParam = '?currency=jpy';

    }

    // 現在開いているページのURLを取得
    var pageUrl = getCurrentPageUrl();

    if( pageUrl !== '' ){
      // リダイレクト先のURL
      var redirectUrl = siteUrl + '/' + pageUrl + queryParam;

    } else {
      // リダイレクト先のURL
      var redirectUrl = siteUrl + queryParam;

    }

    //console.log(redirectUrl);

    window.location.href = redirectUrl;

}
